export default () => {

    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return html_entity_decode(decodeURIComponent(results[2].replace(/\+/g, ' ')));
    }

    function html_entity_decode(str) {
        var textarea = document.createElement("textarea");
        textarea.innerHTML = str;
        return textarea.value;
    }

    function signatureLogoOutput(image_url, link) {
        return `<a style="font-size:16px; margin-top: 3px;" href="${link}">
                    <img alt="photograph" border="0" height="24" style="margin: 10px 0;display:block;border:0;max-width:100%; aspect-ratio: auto 96/24;" 
                    src="${image_url}"></a>`;
    }

    jQuery(($) => {
        $('.signature-role-button').on('click', function() {
            let selectedRole = '';
            if($(this).hasClass('zinnia-b2b')) {
                selectedRole = 'zinnia-b2b';
            } else if($(this).hasClass('zinnia-b2c')) {
                selectedRole = 'zinnia-b2c';
            } else if($(this).hasClass('zinnia-policygenius-b2b')) {
                selectedRole = 'zinnia-policygenius-b2b';
            } else if($(this).hasClass('policygenius-b2b')) {
                selectedRole = 'policygenius-b2b';
            } else if($(this).hasClass('policygenius-b2c')) {
                selectedRole = 'policygenius-b2c';
            } else if($(this).hasClass('policygenius-pro')) {
                selectedRole = 'policygenius-pro';
            } else {
                return;
            }

            $('.signature-role-button').removeClass('active');
            $(this).addClass('active');
            const roleInput = $(`input[value="${selectedRole}"]`);
            if(roleInput.length) {
                roleInput.trigger('click');
            }
        });

        const gfConfirmation = $('#gform_confirmation_message_1');
        if (gfConfirmation.length) {
            $('.signature-roles-wrapper')?.remove();
            $('.signature-roles-heading')?.remove();
        }
    });

    $(document).on('gform_confirmation_loaded', function (event, formId) {
        if (formId != 1) {
            return;
        }

        download("EmailSignature", html);
    });

    if (!getParameterByName('job_title')) {
        return false;
    }

    let img_path = `https://${ window.location.host }/wp-content/themes/zinnia-levit/assets/images`;

    let marginTop = `6px`;
    let html = `
    <HTML lang="en-US">
    <meta charset="utf-8">
    <HEAD>
    <TITLE>Email Signature</TITLE>
    <META content="text/html; charset=utf-8" http-equiv="Content-Type">
    </HEAD>
    <BODY dir="ltr" style="font-size: 11pt; font-family:Arial,Helvetica,sans-serif;">
    <table style="font-family:Arial,Helvetica,sans-serif" cellpadding="0" cellspacing="0">
    <tbody>
    <tr>
    <td style="text-align:left; padding-left:15px;padding-right: 15px;width: 20%;" valign="middle">`;


    let role = getParameterByName('role'),
        logoImageUrl = `${img_path}/zinnia_logo.png?v=2`,
        logoLink = "https://zinnia.com",
        secondLogoImageUrl = '',
        secondLogoLink = '';

    if(['Policygenius B2C'].includes(role)) {
        logoImageUrl = `${img_path}/policygenius.png?v=2`;
        logoLink = "https://www.policygenius.com";
    } else if(['Zinnia & Policygenius B2B', 'Policygenius B2B'].includes(role)) {
        secondLogoImageUrl = `${img_path}/policygenius.png?v=2`;
        secondLogoLink = "https://www.policygenius.com";
    } else if(['Policygenius Pro'].includes(role)) {
        secondLogoImageUrl = `${img_path}/policygenius_pro.png?v=2`;
        secondLogoLink = "https://pro.policygenius.com";
    }

    html += signatureLogoOutput(logoImageUrl, logoLink);
    html += `</td>`;

    if(secondLogoImageUrl !== '') {
        html += `<td style="text-align:left; padding-left:15px;padding-right: 15px;border-left: 2px solid #ccc;" valign="middle">`;
        html += signatureLogoOutput(secondLogoImageUrl, secondLogoLink);
        html += '</td>';
    } else {
        html += "<td></td>"
    }

    html += `</tr>`;
    html += `<tr><td colspan="2" style="vertical-align:top; text-align:left; padding:15px;" valign="top">`;



    let pronounsHtml = getParameterByName('pronouns') && getParameterByName('pronouns') !== '' ? `(${getParameterByName('pronouns')})` : '';
    if (getParameterByName('full_name')) {
        html += `<div style="font-family:Arial,Helvetica,sans-serif;color:#201F20;font-size:18px;font-weight:bold;line-height: 18px;">
            ${getParameterByName('full_name')}<span style="font-size:16px;font-family:Arial,Helvetica,sans-serif; font-weight: normal;"> ${pronounsHtml}</span>
        </div>`;
    }

    if (getParameterByName('job_title')) {
        // color:rgb(102,102,102);
        html += `<div class="full-name" style="margin-top: ${marginTop};font-family:Arial,Helvetica,sans-serif;font-size:16px;">${getParameterByName('job_title')}</div>`;

    }


    if (getParameterByName('email')) {
        html += `<div style="font-family:Arial,Helvetica,sans-serif; color:#6AAB4E; font-size:16px;margin-top: ${marginTop};">
        <a href="mailto:${getParameterByName('email')}" style="color:#201F20;font-size:16px;">${getParameterByName('email')}</a>
        </div>`;
    }


    if (getParameterByName('phone')) {
        let phone = getParameterByName('phone').replace('(', '').replace(') ', '-');
        html += `<div style="font-family:Arial,Helvetica,sans-serif;margin-top: ${marginTop}; color:#6AAB4E; font-size:16px;">
        <a href="mobile:${phone}" style="color:#2c2c2c; text-decoration: none;">P:${phone}</a>
        </div>`
    }
    // html += `<a style="font-size:14px; margin-top: 3px;" href="https://zinnia.com">zinnia.com</a><br>`;
    // html += `<div style="margin-top: 13px; display: flex; align-items: center;"><a href="https://www.linkedin.com/company/zinniatm/" target="_blank"><svg style="margin-right: 5px;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.612.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"/></svg></a>`;
    // html += `<a href="https://twitter.com/zinnia" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.066 9.645c.183 4.04-2.83 8.544-8.164 8.544-1.622 0-3.131-.476-4.402-1.291 1.524.18 3.045-.244 4.252-1.189-1.256-.023-2.317-.854-2.684-1.995.451.086.895.061 1.298-.049-1.381-.278-2.335-1.522-2.304-2.853.388.215.83.344 1.301.359-1.279-.855-1.641-2.544-.889-3.835 1.416 1.738 3.533 2.881 5.92 3.001-.419-1.796.944-3.527 2.799-3.527.825 0 1.572.349 2.096.907.654-.128 1.27-.368 1.824-.697-.215.671-.67 1.233-1.263 1.589.581-.07 1.135-.224 1.649-.453-.384.578-.87 1.084-1.433 1.489z"/></svg></div></a>`;
    html += `</td>
        </tr>`;

    const solution = getParameterByName('solution');
    if(solution && solution !== '-') {
        let solutionLink = 'https://zinnia.com/products/life-annuity-exchange/', solutionImage = `${img_path}/${solution}.png`;

        html += `<tr><td colspan="2" style="vertical-align:top; text-align:left; padding:15px;" valign="top">`;
        if(solutionLink !== '') {
            html += ` <a href="${solutionLink}" target="_blank">`;
        }

        html += `<img src="${solutionImage}" height="44px" style="aspect-ratio: auto 264/44"/>`;

        if(solutionLink !== '') {
            html += `</a>`;
        }

        html += `</td></tr>`;
    }

    html += `</tbody>
        </table>
        </BODY>
        </HTML>`;


    $("#signature-gf-1").on("click", function (e) {
        e.preventDefault();
        download("EmailSignature", html);
    });


    function download(filename, text) {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/html;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

};

